module.exports = __webpack_public_path__ + "static/media/wookaiIcon.49136aae.svg";